export default [
  {
    path: '/admin/facebook-pixel',
    name: 'admin-facebook-pixel',
    component: () => import('@/views/admin/facebook_pixel/FacebookPixelManager.vue'),
    meta: {
      pageTitle: 'Facebook Pixel Manager',
      breadcrumb: [
        { text: 'Admin' },
        { text: 'Facebook Pixel', active: true },
      ],
    },
  },
]